import { Component, Input } from '@angular/core';
import {AbstractControl, FormControl} from '@angular/forms';

export interface ErrorMessages {
    pattern?: string;
    required?: string;
}

@Component({
    selector: 'app-input-error',
    templateUrl: './input-error.component.html',
    styleUrls: ['./input-error.component.scss']
})
export class InputErrorComponent {

    @Input()
    field: FormControl | AbstractControl;

    @Input()
    messages: ErrorMessages | any;

    @Input()
    icon = true;

    constructor() { }

    hasSomeError() {
        return this.field.invalid && (this.field.dirty || this.field.touched);
    }

}
